import * as React from 'react';
import { clsx } from 'clsx';
import { Checkbox } from '../../../../checkbox';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var MultiSelectDesktopDropdownItem = /*#__PURE__*/React.forwardRef(function MultiSelectDesktopDropdownItem(_ref, forwardedRef) {
  var value = _ref.value,
    label = _ref.label,
    name = _ref.name,
    focused = _ref.focused,
    selected = _ref.selected,
    dataTestId = _ref.dataTestId,
    onClick = _ref.onClick,
    onMouseMove = _ref.onMouseMove;
  return /*#__PURE__*/_jsx("div", {
    ref: focused ? forwardedRef : undefined,
    className: clsx(styles['checkbox-wrapper'], focused && styles['focused']),
    onClick: onClick,
    onMouseMove: onMouseMove,
    role: "option",
    "aria-selected": selected ? 'true' : undefined,
    tabIndex: 0,
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(Checkbox, {
      name: name,
      value: value,
      checked: selected,
      label: label,
      tabIndex: -1,
      onClick: preventDefault
    })
  });
});
function preventDefault(event) {
  event.preventDefault();
}